













































import _ from 'lodash'
import moment from 'moment'
import { DataTablePagination } from '@/types/_'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import ModalRegraDeCalculoIncluirSetorAtendimento from './ModalRegraDeCalculoIncluirSetorAtendimento.vue'
import EventBus from '@/plugins/EventBus'

@Component({
  components: {
    ModalRegraDeCalculoIncluirSetorAtendimento,
  },
})
export default class SetorAtendimentoDataTable extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadOperadoras: boolean = false
  get loadingOperadoras() { return this.loadOperadoras }
  set loadingOperadoras(value: boolean) { this.loadOperadoras = value }

  get header() {
    return [
      { text: 'Nome Setor de Atendimento', value: 'setorAtendimentoNome', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get itemsSetorAtendimento() {
    return this.getRegrasDeCalculoStore.setorAtendimentoTable || []
  }
  get paginacaoSetorAtendimento() { return this.getRegrasDeCalculoStore.paginacaoSetorAtendimento }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  loadDeletarRegraDeCalculoOperadora: string = ''
  get loadingDeleteRegraSetorAtendimento() { return this.loadDeletarRegraDeCalculoOperadora }
  set loadingDeleteRegraSetorAtendimento(value: string) { this.loadDeletarRegraDeCalculoOperadora = value }

  get showModal() { return this.getRegrasDeCalculoStore.modal.setorAtendimento }
  set showModal(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'setorAtendimento', value }) }

  async removeRegra(regraId: string) {
    this.loadingDeleteRegraSetorAtendimento = regraId
    const request = await this.getRegrasDeCalculoStore.removeSetorAtendimento(regraId)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeleteRegraSetorAtendimento = ''
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Setor atendimento excluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingDeleteRegraSetorAtendimento = ''
  }
}
